import { EProductEditions } from 'enums/EProductEditions';
import { useRMSelector } from 'redux/hooks';
import { selectProductEdition } from 'redux/selectors/StateSelectors';

const useProductEdition = (): EProductEditions => {
  return useRMSelector(selectProductEdition);
};

export default useProductEdition;
